'use client'

import { ShareLinks } from '@/config/constants'
import { useTranslations } from 'next-intl'
import Icon, { IconName } from '@/components/atoms/Icon'
import { Label } from '@/components/atoms/Typography'
import { useToast } from '@/components/molecules/Toast'
import styles from './Share.module.scss'
import { ShareItemProps } from './Share.types'

const buildLink = (id: keyof typeof ShareLinks, value: string) => {
  if (!ShareLinks[id]) return ''
  const link = ShareLinks[id]

  return `${link}${value}`
}

const ShareItem = ({ id, type, icon, title, value }: ShareItemProps) => {
  const t = useTranslations('General')
  const { success } = useToast()
  const link = buildLink(id, value)
  const InnerContent = () => (
    <>
      <div className={styles.icon}>
        <Icon iconName={icon as IconName} />
      </div>
      <Label size='xs'>{title}</Label>
    </>
  )

  const handleClick = () => {
    navigator.clipboard.writeText(window.location.href)
    success(t('copyShare'), {
      persistent: false,
    })
  }

  return type === 'link' ? (
    <a
      href={link}
      target='_blank'
      className={styles.shareItem}
      rel='noopener noreferrer'
    >
      <InnerContent />
    </a>
  ) : (
    <button
      type='button'
      onClick={handleClick}
      className={styles.shareItem}
    >
      <InnerContent />
    </button>
  )
}

export default ShareItem
